<script setup lang="ts">
import type { NavItem } from '@nuxt/content'
import { type SearchItems, titleCase } from './util'

const { page } = useContent()

const isIndex = computed(() => page.value?._path === '/')

const search: Ref<SearchItems> = inject('search', ref({} as SearchItems))

const links = computed(() => {
  const pages = Object.values(search.value)
  const parts = page.value?._path!.split('/').slice(1, -1) ?? []

  return parts.map((part: string, index: number) => {
    const path = '/' + parts.slice(0, index + 1).join('/')
    const page = pages.find((p: NavItem) => p._path === path)
    const label = titleCase(page?.title || part.replaceAll(/[_-]/g, ' '))
    if (!page || page._id?.endsWith?.('_dir.yml')) return { label }
    return { label, path: page._path }
  })
})
</script>

<template>
  <nav v-if="!isIndex" class="breadcrumbs">
    <div v-for="({ path, label }, index) in links" :key="path" class="breadcrumb title-font">
      <Icon v-if="index !== 0" name="estia:triquetra" class="chevron" />
      <NuxtLink v-if="path" :key="path + label" :to="path" no-prefetch class="link">
        {{ label }}
      </NuxtLink>
      <span v-else :key="'missing ' + path + label" class="no-link">
        {{ label }}
      </span>
    </div>
  </nav>
</template>

<style scoped lang="postcss">
.breadcrumbs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 1.5rem;
  gap: 0.25rem 0.75rem;

  @media screen and (max-width: 950px) {
    margin-bottom: 0.25rem;
    font-size: 0.9em;
    justify-content: center;
  }

  .breadcrumb {
    display: contents;

    .chevron {
      color: var(--text-highlight);
    }
  }
}
</style>
